import React from "react";
import { MiraInbox } from "@/pages/AdminDashboard";
import LegacyHost from "@/pages/admin/os/LegacyHost";

export default function MiraInboxPage() {
  return (
    <LegacyHost
      title="Mira Inbox"
      migratedFrom="Editorial desk · Inbox — Mira"
      testid="os-operate-mira"
    >
      <MiraInbox />
    </LegacyHost>
  );
}
